import { render, staticRenderFns } from "./WindSpotEdit.vue?vue&type=template&id=19bc322c&"
import script from "./WindSpotEdit.vue?vue&type=script&lang=js&"
export * from "./WindSpotEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports